import { useState } from "react";
import { useAuthStore } from "../stores/auth";
import { Button } from "../components/ui/button";
import { Input, Field } from "../components/ui/input";

export function Login() {
  const login = useAuthStore((s) => s.login);
  const [email, setEmail] = useState("brice@umbeli.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  return (
    <div className="login">
      <form
        className="login__form"
        onSubmit={async (e) => {
          e.preventDefault();
          setError(null);
          setSubmitting(true);
          try {
            await login(email, password);
          } catch {
            setError("Identifiants invalides");
          } finally {
            setSubmitting(false);
          }
        }}
      >
        <div>
          <h1 className="login__title">Voice Responder</h1>
          <p className="login__subtitle">Tableau de bord Umbeli</p>
        </div>
        <Field label="Email">
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </Field>
        <Field label="Mot de passe">
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
        </Field>
        {error ? <p className="login__error">{error}</p> : null}
        <Button variant="primary" type="submit" disabled={submitting}>
          {submitting ? "Connexion…" : "Se connecter"}
        </Button>
      </form>
    </div>
  );
}
